import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { CompanyGroupRequest } from '../models';
import { tap } from 'rxjs/operators';
import { Storage } from '@ionic/storage-angular';

@Injectable()
export class CompanyGroupService {
  private static config: any;

  constructor(private httpService: HttpService, private _storage: Storage) {}

  public getCompanyGroupInfo(payload: CompanyGroupRequest): Observable<void> {
    return this.httpService.makePost<any, any>('getsolocompany', payload);
  }

  public static getConfig() {
    return this.config;
  }

  public getCompanyGroup(payload: CompanyGroupRequest): Observable<void> {
    return this.httpService.makePost<any, any>('getsolocompany', payload).pipe(tap((config) => (CompanyGroupService.config = config)));
  }

  public getCompanyGroupDomain(payload: string): Observable<void> {
    return this.httpService
      .makePost<any, any>('getsolocompanydomain', payload)
      .pipe(tap((config) => (CompanyGroupService.config = config)));
  }

  public setConfig(_config: any) {
    CompanyGroupService.config = _config;
  }

  public clearData() {
    setTimeout(async () => {
      const storage = await this._storage.create();
      await storage.keys();
      localStorage.removeItem('authenticationFeature');
      this._storage.remove('CART_DATE_TIME');
      this._storage.remove('CART');
      const ALLERGENS_AGREED = await this._storage.get('ALLERGENS_AGREED');
      if (ALLERGENS_AGREED) {
        await this._storage.remove('ALLERGENS_AGREED');
      }
    }, 0);
  }

  public getDominHost() {
    return `"${location.origin}"`;
  }
}
